var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"socials__icon",class:{'installed': _vm.isInstalled},on:{"click":_vm.addSocial}},[_c('svg-icon',{attrs:{"width":"20","height":"20","icon":_vm.model.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }